import React, {
  Fragment,
  FunctionComponent,
  ReactElement,
} from 'react';
import { useTranslation } from 'react-i18next';
import {
  Menu,
  MenuItem,
  MenuDivider,
} from '@blueprintjs/core';
import './user-menu-content.scss';

type UserMenuContentProps = {
  firstName?: string
  lastName?: string
  username: string
  passwordUpdate: () => void
  onLogout: () => void
  onAboutClick: () => void
}

const UserMenuContent: FunctionComponent<UserMenuContentProps> = ({
  firstName,
  lastName,
  username,
  passwordUpdate,
  onLogout,
  onAboutClick,
}: UserMenuContentProps): ReactElement => {
  const { t } = useTranslation();

  const getTitle = () => {
    const name = [firstName ?? '', lastName ?? ''].join(' ').trim();

    return (
      <Fragment>
        {name}{' '}<span className="user-menu-content-username">({username})</span>
      </Fragment>
    );
  };

  return (
    <Menu>
      <MenuDivider title={getTitle()} />
      <MenuDivider />
      <MenuItem icon="key" text={t('common.menu.changePassword')} onClick={passwordUpdate} />
      <MenuItem icon="help" text={t('common.menu.help')} href={`${process.env.PUBLIC_URL}/help/index.html`} target="_blank" />
      <MenuItem icon="info-sign" text={t('common.menu.about')} onClick={onAboutClick} />
      <MenuItem
        icon="log-out"
        text={t('common.menu.logout')}
        onClick={onLogout}
      />
    </Menu>
  );
};

export default UserMenuContent;
